module.exports = __webpack_public_path__ + "static/media/3x3.f81680e3.kra";